var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.97656 13.125C10.7031 13.125 11.3125 13.7344 11.3125 14.4375C11.3125 15.1641 10.6797 15.75 9.97656 15.75C9.27344 15.75 8.6875 15.1641 8.6875 14.4375C8.6875 13.7344 9.27344 13.125 9.97656 13.125ZM17.3125 8.03906C17.5469 8.25 17.5469 8.60156 17.3125 8.83594C17.1953 8.95312 17.0547 9 16.9141 9C16.7969 9 16.6562 8.95312 16.5391 8.85938C14.8984 7.28906 12.5078 6.375 10 6.375C7.46875 6.375 5.07812 7.28906 3.4375 8.85938C3.20312 9.07031 2.85156 9.07031 2.64062 8.83594C2.42969 8.60156 2.42969 8.25 2.66406 8.03906C4.51562 6.28125 7.1875 5.25 10 5.25C12.7891 5.25 15.4609 6.28125 17.3125 8.03906ZM10 9.375C11.7812 9.375 13.4453 10.0312 14.6641 11.2266C14.8984 11.4375 14.8984 11.8125 14.6875 12.0234C14.5703 12.1406 14.4297 12.1875 14.2891 12.1875C14.1484 12.1875 14.0312 12.1406 13.9141 12.0469C12.8828 11.0625 11.5 10.5 10 10.5C8.47656 10.5 7.09375 11.0625 6.0625 12.0469C5.85156 12.2578 5.47656 12.2578 5.26562 12.0234C5.05469 11.8125 5.05469 11.4375 5.28906 11.2266C6.53125 10.0312 8.19531 9.375 10 9.375Z",
    fill: "#FFA800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.56d533580390ea968bf35e44fb05b009.svg";
export { ForwardRef as ReactComponent };